import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Container, Button, Typography, Divider } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import { useAlert } from "../../components/Alert";
import {
  uploadProgramInputs,
  downloadProgramTemplate,
} from "../../api/programs";

export default function UploadProgramInputs() {
  const navigate = useNavigate();
  const { programId } = useParams();
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const { showAlert } = useAlert();

  const onFileChange = (event) => {
    const file = event.target.files[0];
    setFormData({ ...formData, [event.target.name]: file });
  };

  const handleSubmit = async () => {
    if (!formData.input_file) {
      showAlert("error", "Please select a file");
      return;
    }
    await uploadProgramInputs(programId, formData);
    navigate(`/programs/program/${programId}`);
  };

  const downloadTemplateFile = async () => {
    downloadProgramTemplate();
  };

  return (
    <>
      <CustomAppBar title="Create Program" />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Upload Program Inputs")}</CustomTitle>

            <CustomButton onClick={downloadTemplateFile}>
              {t("Download Template")}
            </CustomButton>

            <Divider sx={{ mt: 10, mb: 10 }} />

            <input
              type="file"
              name="input_file"
              accept=".csv,text/csv"
              onChange={onFileChange}
              style={{ display: "none" }}
              id="input-file"
            />
            <Button
              variant="contained"
              component="label"
              style={{
                marginLeft: "auto",
                color: "white",
                width: "100%",
                height: "33px",
              }}
              htmlFor="input-file"
            >
              <Typography variant="caption">
                {formData.input_file
                  ? formData.input_file.name
                  : t("Select File")}
              </Typography>
            </Button>
            <CustomButton onClick={handleSubmit}>{t("Upload")}</CustomButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
